import React, { useContext, useEffect } from 'react'
import { GoogleMap, Polyline, useLoadScript } from '@react-google-maps/api'
import { ExtendedItineraryItem, ItineraryMapMarker } from '@/interfaces'
import ItineraryMapMarkerComponent from '@/components/models/itinerary/ItineraryMap/ItineraryMapMarker'
import { AppConfigContext } from '@/app/providers/AppConfigProvider'
// import Spiderfy from './Spiderfy'

const extractMarkers = (items: ExtendedItineraryItem[]): ItineraryMapMarker[] => {
  const markerPositions: ItineraryMapMarker[] = []
  items.forEach((item, index) => {
    item.mapMarkers.map((mapMarker) => {
      markerPositions.push({
        itemIndex: index,
        position: {
          lat: parseFloat(mapMarker.lat),
          lng: parseFloat(mapMarker.lng),
        },
      })
    })
  })
  return markerPositions
}

const extractMarkerPositions = (markers: { position: google.maps.LatLngLiteral }[]) => {
  return markers.map((marker) => {
    return marker.position
  })
}

const containerStyle = {
  width: '100%',
  height: '400px',
}

const options = {
  mapTypeControl: false,
  streetViewControl: false,
  mapId: process.env.NEXT_PUBLIC_GMAP_MAPID,
}

type Libraries = ('drawing' | 'geometry' | 'localContext' | 'places' | 'visualization')[]
const libraries: Libraries = ['places']

interface Props {
  extendedItineraryItems: ExtendedItineraryItem[]
}

function ItineraryMap({ extendedItineraryItems }: Props) {
  const appConfig = useContext(AppConfigContext)
  const { isLoaded } = useLoadScript({
    id: 'tour-map',
    googleMapsApiKey: process.env.NEXT_PUBLIC_GCP_API_KEY as string,
    libraries: libraries,
  })

  const markers = extractMarkers(extendedItineraryItems)
  const markerPositions = extractMarkerPositions(markers)
  const [map, setMap] = React.useState<google.maps.Map | null>(null)
  const [openMarkerIndex, setOpenMarkerIndex] = React.useState<number>()

  // map
  const onLoad = React.useCallback(function callback(map: google.maps.Map) {
    const bounds = new window.google.maps.LatLngBounds()
    markerPositions.forEach((position) => {
      bounds.extend(position)
    })
    map.fitBounds(bounds)
    setMap(map)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const onUnmount = React.useCallback(function callback() {
    setMap(null)
  }, [])

  useEffect(() => {
    if (map) {
      const bounds = new window.google.maps.LatLngBounds()
      markerPositions.forEach((position) => {
        bounds.extend(position)
      })
      // @ts-ignore
      map.fitBounds(bounds)
      setMap(map)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [markers])

  if (!markers.length) {
    return <></>
  }

  return isLoaded ? (
    <GoogleMap options={options} mapContainerStyle={containerStyle} onLoad={onLoad} onUnmount={onUnmount}>
      <>
        {/*<Spiderfy*/}
        {/*  onSpiderClick={(e, index) => {*/}
        {/*    toggleOpenMarker(index)*/}
        {/*  }}*/}
        {/*>*/}
        {markers.map((marker, index: number) => {
          return (
            <ItineraryMapMarkerComponent
              marker={marker}
              extendedItineraryItem={extendedItineraryItems[marker.itemIndex]}
              index={index}
              openInfoWindow={() => setOpenMarkerIndex(index)}
              closeInfoWindow={() => setOpenMarkerIndex(undefined)}
              isOpen={openMarkerIndex === index}
              key={index}
            />
          )
        })}
        {/*</Spiderfy>*/}
        <Polyline path={markerPositions} options={{ strokeColor: appConfig.googleMap.polyline.strokeColor }} />
      </>
    </GoogleMap>
  ) : (
    <></>
  )
}

export default ItineraryMap
